import { render, staticRenderFns } from "./qSelectLives.vue?vue&type=template&id=4c4a0889&scoped=true&"
import script from "./qSelectLives.vue?vue&type=script&lang=ts&"
export * from "./qSelectLives.vue?vue&type=script&lang=ts&"
import style0 from "./qSelectLives.vue?vue&type=style&index=0&id=4c4a0889&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4a0889",
  null
  
)

export default component.exports